import {
  AfterViewInit,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgForm, FormBuilder, Validators } from "@angular/forms";
import { SessionStorageService, LocalStorageService } from "ngx-webstorage";
import { AppQueries, Dispatcher, GetInfoUser } from "src/app/state";
import { ShortcutService } from "src/app/common/service/shortcut.service";
import { Subscription } from "rxjs";
import { EventManagerService } from "src/app/common/service/event-manager.service";
import { Constant } from "src/app/common/constant";
import { DialogService } from "src/app/common/service/dialog.service";
import { EditComponent } from "src/app/common/extend-code/edit.component";
import { UserProfile } from "src/app/common/models/users.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ProfileService } from "src/app/profile-user/profile-user.service";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "create-appointment-popup",
  styleUrls: ["./create-appointment-popup.component.scss"],
  templateUrl: "./create-appointment-popup.component.html",
})
export class CreateAppointmentPopupComponent
  extends EditComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  public Constant = Constant;
  subscriptions?: Subscription[] = [];
  userProfile: UserProfile;
  constructor(
    private fb: FormBuilder,
    public eventManager: EventManagerService,
    public profileService: ProfileService,
    private dialog: DialogService,
    public ngModal: NgbModal,
    public route: ActivatedRoute,
    public sessionStorageService: SessionStorageService,
    private dispatcher: Dispatcher,
    private appQueries: AppQueries
  ) {
    super(eventManager, route);
  }

  ngOnInit() {
    this.subscriptions = [
      this.appQueries.userProfile$.subscribe((userProfile) => {
        this.userProfile = userProfile;
        this.detailObject = this.userProfile || new UserProfile();
        this.updateForm();
      }),
    ];
    ShortcutService.addOneKey(13, this.save.bind(this));
  }
  ngOnDestroy() {
    ShortcutService.removeFuncEsc();
    this.eventManager.destroys(this.subscriptions);
  }
  ngAfterViewInit() {
    this.dialog.destroy();
  }
  dismiss() {
    this.ngModal.dismissAll();
  }
}
